import {
    faInstagram,
    faTelegram,
    faTwitter,
} from '@fortawesome/free-brands-svg-icons';
import {
    faBus,
    faCar,
    faHotel,
    faPlaneDeparture,
    faSuitcaseRolling,
    faTrain,
} from '@fortawesome/pro-regular-svg-icons';
import { SiteEnv } from '@env/types';
import { ReserveType } from '@utils/itinerary';

export default function useSiteConfigs() {
    const { whiteLabel } = useWhiteLabel();
    switch (whiteLabel) {
        case 'airplaneticket':
            return {
                env: SiteEnv.AirplaneTicket,
                title: 'ایرپلین تیکت',
                lightLogo: '/airplaneticket/logo-light.png',
                darkLogo: '/airplaneticket/logo-dark.png',
                panelBack: '/airplaneticket/img/panel/back.svg',
                baseUrl: 'airplaneticket.ir',
                reserves: [
                    {
                        type: ReserveType.Flight,
                        title: 'بلیط هواپیما',
                        link: '/',
                        icon: faPlaneDeparture,
                    },
                ],
                showBanners: false,
                footerDescription:
                    'این وب سایت امکان رزرو بلیط هواپیما به صورت آنلاین را فراهم کرده است. برای شروع، پرواز مورد نیازتان را جستجو کنید تا همه ی پروازهای سیستمی شرکت های هواپیمایی و پروازهای چارتری بیش از دویست چارترکننده کشور به شما نمایش داده شود. سپس مناسبترین پرواز را از نظر زمان پرواز و قیمت بلیط از میان آنها انتخاب نمایید و با پرداخت آنلاین صورتحساب، خرید بلیط هواپیما را کامل کنید. رزرو بلیط هواپیما از این وب سایت بسیار ساده بوده و بلیط ها از طریق ایمیل، پیامک و یا فکس به سفارش شما برایتان ارسال می شود و پس از آن نیز دیگر نیازی به مراجعه حضوری ندارید. فقط بلیط ها را بررسی کنید و یک ساعت قبل از پرواز در فرودگاه حاضر شوید!',
                email: 'salam@airplaneticket.ir',
                socialNetworks: [
                    {
                        href: 'https://t.me/AirplaneTicket',
                        icon: faTelegram,
                    },
                    {
                        instagram: 'https://instagram.com/airplaneticket.ir',
                        icon: faInstagram,
                    },
                ],
                footerVariantLinks: [
                    {
                        title: 'پرسش‌های متداول',
                        href: '/support/faq',
                    },
                    {
                        title: 'راهنمای خرید اینترنتی',
                        href: '/support/guide/payment',
                    },
                    {
                        title: 'پیشنهادها و شکایات',
                        href: '/support/feedback',
                    },
                    {
                        title: 'مجله ایرپلین تیکت',
                        href: 'https://mag.airplaneticket.ir',
                    },
                    {
                        title: 'شرایط و مقررات',
                        href: '/support/terms-and-conditions',
                    },
                    {
                        title: 'فرصت‌های شغلی',
                        href: 'https://careers.mrbilit.com',
                        rel: 'noopener noreferrer nofollow',
                    },
                ],
                reserveLinks: [],
                enamadHref:
                    'https://trustseal.enamad.ir/?id=9453&code=Uno5uiZLuaK1zUW9OgbV',
                shamedHref:
                    'https://logo.samandehi.ir/Verify.aspx?id=26015&p=uiwkgvkaobpdrfthdshw',
                seoMeta: {
                    title: 'AirplaneTicket.ir - !یک جستجو، همه پروازها',
                    description:
                        'ایرپلین تیکت وب سایت معتبری است که از سال 1392 در زمینه بلیط هواپیما فعالیت می کند و بهترین خدمات را فراهم کرده است.',
                },
            };
        default:
            return {
                title: 'مِستربلیط',
                lightLogo: '/img/newLayout/MrBilit-farsi-logo-white.svg',
                darkLogo: '/img/newLayout/MrBilit-farsi-logo.svg',
                panelBack: '/img/panel/back.svg',
                baseUrl: 'mrbilit.com',
                reserves: [
                    {
                        type: ReserveType.Flight,
                        title: 'بلیط هواپیما',
                        link: '/plane-ticket',
                        icon: faPlaneDeparture,
                    },
                    {
                        type: ReserveType.Hotel,
                        title: 'رزرو هتل',
                        link: '/hotel',
                        icon: faHotel,
                    },
                    {
                        type: ReserveType.Bundle,
                        title: 'بسته سفر',
                        link: '/tour',
                        icon: faSuitcaseRolling,
                    },
                    {
                        type: ReserveType.Train,
                        title: 'بلیط قطار',
                        link: '/train-ticket',
                        icon: faTrain,
                    },
                    {
                        type: ReserveType.Bus,
                        title: 'بلیط اتوبوس',
                        link: '/bus-ticket',
                        icon: faBus,
                    },
                    {
                        type: ReserveType.Taxi,
                        title: 'بلیط سواری',
                        link: '/taxi',
                        icon: faCar,
                    },
                ],
                showBanners: true,
                email: 'salam@mrbilit.com',
                footerDescription: '',
                socialNetworks: [
                    {
                        href: 'https://twitter.com/mrbilit',
                        icon: faTwitter,
                        rel: 'nofollow',
                    },
                    {
                        href: 'https://t.me/mrBilit',
                        icon: faTelegram,
                        rel: 'nofollow',
                    },
                    {
                        href: 'https://instagram.com/mrbilit',
                        icon: faInstagram,
                        rel: 'nofollow',
                    },
                ],
                footerVariantLinks: [
                    {
                        title: 'پرسش‌های متداول',
                        href: '/support/faq',
                    },
                    {
                        title: 'پیشنهادها و شکایات',
                        href: '/support/feedback',
                    },
                    {
                        title: 'شرایط و مقررات',
                        href: '/support/terms-and-conditions',
                    },
                    {
                        title: 'مجله مِستربلیط',
                        href: 'https://mrbilit.com/mag/',
                    },
                    {
                        title: 'راهکار سازمانی',
                        href: 'https://mrbilit.com/b2b',
                    },
                    {
                        title: 'فرصت‌های شغلی',
                        href: 'https://careers.mrbilit.com',
                        rel: 'noopener noreferrer nofollow',
                    },
                    {
                        title: 'درباره ما',
                        href: '/support/who-is-he',
                    },
                ],
                reserveLinks: [
                    {
                        title: 'بلیط هواپیما استانبول',
                        href: '/flights/IST',
                    },
                    {
                        title: 'بلیط هواپیما نجف',
                        href: '/flights/NJF',
                    },
                    {
                        title: 'رزرو هتل تهران',
                        href: '/hotel/tehran',
                    },
                    {
                        title: 'رزرو هتل مشهد',
                        href: '/hotel/mashhad',
                    },
                    {
                        title: 'رزرو هتل اصفهان',
                        href: '/hotel/isfahan',
                    },
                    {
                        title: 'رزرو هتل کیش',
                        href: '/hotel/kish',
                    },
                    {
                        title: 'رزرو هتل قشم',
                        href: '/hotel/qeshm',
                    },
                    {
                        title: 'رزرو هتل شیراز',
                        href: '/hotel/shiraz',
                    },
                ],
                enamadHref:
                    'https://trustseal.enamad.ir/?id=11035&Code=AvcTv5TLRY1luModcMc5',
                shamedHref:
                    'https://logo.samandehi.ir/Verify.aspx?id=26016&p=uiwkgvkaobpdrfthgvka',
                seoMeta: {
                    description:
                        'مِستربلیط وب سایت و اپلیکیشنی برای خرید ارزان و اینترنتی بلیط هواپیما، بلیط قطار و بلیط اتوبوس به صورت ساده، سریع و ارزان است. کافیست برای رزرو بلیط، مسیر و تاریخ را مشخص کنید تا مِستربلیط تمام موارد را جستجو کرده و بلیط ارزان به مقصد دلخواه شما را پیشنهاد دهد.',
                },
            };
    }
}
